import { SUPPORTED_MISSION_TYPES } from 'utils/constants';

export const INITIAL_MISSIONS_QUERY_PARAMS = {
  atleastonedone: '1',
  missionChecked: '0',
  labelingType: SUPPORTED_MISSION_TYPES,
};

export const TYPES = {
  missionChecked: 'missionChecked',
  atleastonedone: 'atleastonedone',
  checkValidated: 'checkValidated',
  labelingType: 'labelingType',
  name: 'name',
  reset: 'reset',
};

export default function reducer(state = {}, action) {
  switch (action.type) {
    case TYPES.missionChecked:
    case TYPES.atleastonedone:
    case TYPES.checkValidated:
    case TYPES.name:
      return { ...state, [action.type]: action.payload };
    case TYPES.labelingType:
      return { ...state, labelingType: action.payload };

    case TYPES.reset:
      return INITIAL_MISSIONS_QUERY_PARAMS;

    default:
      throw new Error(`action type "${action.type}" is not supported`);
  }
}
